import React from 'react'
import PropTypes from 'prop-types'
import { Button, Input } from 'loyal-react'

const Form = ({ email, handleEmail, saveEmail, isLoading }) => {
  return (
    <div className='col-12 mt-2'>
      <div className={`row mx-0`}>
        <div className='col mr-auto px-0'>
          <Input
            id='virtualVoucher-email'
            className='col-12 pl-0'
            labelClass='l-1 pl-half'
            label='E-mail'
            value={email}
            onChange={handleEmail}
          />
        </div>
        <div className='col-auto px-0'>
          <Button
            id='virtualVoucher-btn-saveEmail'
            className='btn-icon btn-featured btn-icon-only'
            iconName='icon_check'
            onClick={saveEmail}
            loading={isLoading}
          />
        </div>
      </div>
    </div>
  )
}

Form.propTypes = {
  email: PropTypes.string,
  handleEmail: PropTypes.func.isRequired,
  saveEmail: PropTypes.func.isRequired,
  isLoading: PropTypes.bool
}

export default Form



// WEBPACK FOOTER //
// ./src/features/Cart/Summary/VirtualVoucher/Form/Form.js